import { Router } from "express";
import { postController } from "./post.controller";
import { auth } from "../../middlewares/auth";
import { Role } from "../../../generated/prisma/enums";

const router = Router();

router.post(
  "/",
  auth(Role.USER, Role.ADMIN, Role.AUTHOR),
  postController.createPost,
);

router.get("/", auth(Role.ADMIN), postController.getAllPosts);

router.get("/", postController.getAllPosts);

router.get("/WithFilter", postController.getAllPostsWithFilter);

router.get("/WithSearch", postController.getAllPostsWithSearch);

// ? Filtering with exact match (AND Operator) and Search with Partial Match (OR Operator)
router.get(
  "/WithFilterAndSearch",
  postController.getAllPostsWithFilterAndSearch,
);

// ? All Post with Pagination
router.get("/WithPagination", postController.getAllPostsWithPagination);

// ? All Post with Dynamic Pagination
router.get(
  "/WithDynamicPagination",
  postController.getAllPostsWithDynamicPagination,
);

router.get("/stats", auth(Role.ADMIN), postController.getPostsStats);

router.get(
  "/my-posts",
  auth(Role.USER, Role.ADMIN, Role.AUTHOR),
  postController.getMyPosts,
);

router.get("/:postId", postController.getPostById);

router.patch(
  "/:postId",
  auth(Role.USER, Role.ADMIN, Role.AUTHOR),
  postController.updatePost,
);

router.delete(
  "/:postId",
  auth(Role.USER, Role.ADMIN, Role.AUTHOR),
  postController.deletePost,
);

export const postRoutes = router;
